import {observable, action} from 'mobx';
import {EXAM_PREP_ROLES} from 'constants/usersConstrains';

class UserStore {

  @observable user = null;

  @action
  initUser = () => {
    this.user = JSON.parse(localStorage.getItem('user'));
  };

  @action
  setUser = user => {
    this.user = user
  };

  @action
  loginUser = (user, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    this.user = user;
  };

  @action
  logout = () => {
    localStorage.clear();
    this.user = null;
  };

  @action
  update = user => {
    localStorage.setItem('user', JSON.stringify(user));
    this.user = user;
  };

  isAdmin = () => {
    return this.user && this.user.role === 'admin';
  };

  full_name = () => {
    return `${this.user.first_name}  ${this.user.last_name}`
  }

  isExamPrepUser = () => {
    return EXAM_PREP_ROLES.includes(this.user.user_type);
  };

}

export default new UserStore();



// WEBPACK FOOTER //
// ./src/stores/userStore.js